import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	feedbackTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackContentText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	giveFeedbackText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	feedbackTitle: {
		id: 'command-palette-integration.controllers.use-feedback-collector.feedback-title',
		defaultMessage: 'Share your thoughts',
		description: 'Title of the feedback collector dialog',
	},
	feedbackButtonText: {
		id: 'command-palette-integration.controllers.use-feedback-collector.feedback-button-text',
		defaultMessage: 'Let us know',
		description: 'Text of button to open feedback collector dialog',
	},
	feedbackContentText: {
		id: 'command-palette-integration.controllers.use-feedback-collector.feedback-content-text',
		defaultMessage: 'Got feedback?',
		description: 'Text of button to open feedback collector dialog in the command palette',
	},
	giveFeedbackText: {
		id: 'command-palette-integration.controllers.use-feedback-collector.give-feedback-text',
		defaultMessage: 'Give feedback',
		description: 'Text of button to open feedback collector dialog in the command palette footer',
	},
});
